import { useState } from 'react';
import { InjectedFieldProps, PublicFieldProps } from 'react-admin';
import { JobPhaseReceivableSheetInterface } from '@vatos-pas/common';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core';

import InfoDialog from 'components/InfoDialog';

type AddressFieldProps = PublicFieldProps &
  InjectedFieldProps<JobPhaseReceivableSheetInterface>;

const formatReceivableAddress = (
  record: JobPhaseReceivableSheetInterface,
): string => {
  const streetParts = [record.address1, record.address2].filter(
    part => part && part.trim().length > 0,
  );
  const stateZip = [record.state, record.zip].filter(Boolean).join(' ');
  const parts = [
    streetParts.join(', '),
    record.city,
    stateZip,
  ].filter(p => p && p.trim().length > 0);
  return parts.join(', ');
};

const useStyles = makeStyles({
  infoWarning: {
    color: '#ff9800',
  },
});

export const AddressField = ({ record }: AddressFieldProps) => {
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!record || !record.address1) return null;

  const fullAddress = formatReceivableAddress(record);

  return (
    <Box display="flex" alignItems="center" gridColumnGap={4}>
      <IconButton onClick={() => setIsModalOpen(true)}>
        <InfoOutlinedIcon className={classes.infoWarning} />
      </IconButton>
      <InfoDialog
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        title="Address"
        content={<Typography>{fullAddress}</Typography>}
      />
    </Box>
  );
};

export default AddressField;
